var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('v-icon',_vm._g({attrs:{"color":"success","small":""}},_vm.$listeners),[_vm._v("check_circle_outline")]):_c('v-icon',_vm._g({attrs:{"color":"error","small":""}},_vm.$listeners),[_vm._v("highlight_off")])}
var staticRenderFns = []

export { render, staticRenderFns }